import { render } from "./NgayLe.vue?vue&type=template&id=61f03421&scoped=true"
import script from "./NgayLe.vue?vue&type=script&lang=js"
export * from "./NgayLe.vue?vue&type=script&lang=js"

import "./NgayLe.vue?vue&type=style&index=0&id=61f03421&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f03421"]])

export default __exports__